import React from 'react';
import {MENU_IDS} from '../../../constants/menuIds';
import {ISlide} from '../../../incase-domain/slide';
import {ContextMenuTrigger} from '../../../incase-domain/components/contextMenu/ContextMenu';

interface SlidePreviewContextMenuTriggerProps {
    slide: ISlide | undefined;
    mutateSlide: (cb?: () => void) => void;
    selectedSlides?: ISlide[];
}

export function SlidePreviewContextMenuTrigger({
    slide,
    mutateSlide,
    selectedSlides,
    children,
}: React.PropsWithChildren<SlidePreviewContextMenuTriggerProps>): JSX.Element | null {
    if (!slide) return <>{children}</>;

    return (
        <ContextMenuTrigger menuId={MENU_IDS.SLIDE_PREVIEW} menuProps={{slide, mutateSlide, selectedSlides}}>
            {children}
        </ContextMenuTrigger>
    );
}

export default SlidePreviewContextMenuTrigger;
